import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import BigImgScroll from '../../../common-components/big-img-scroll';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Graph = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} caseName="converter-graph">
                <CommonTitle className="converter-graph__title">
                    График роста посещений за&nbsp;2&nbsp;года с&nbsp;момента создания сервиса
                </CommonTitle>
                <ScrollAnimation
                    animateIn="fadeInUp"
                    offset={100}
                    deley={100}
                    animateOnce={true}
                    duration={1}
                >
                    <div className="converter-graph__img">
                        <BigImgScroll img="/images/pic/converter/converter-graph.png" />
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Graph;
